import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from '@models/menu-item';

@Component({
  standalone: false,
  selector: 'app-item-divider',
  templateUrl: './item-divider.component.html',
  styleUrls: ['./item-divider.component.scss']
})
export class MenuItemDividerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}
